import * as React from "react";

export class MtaSuccessModalWording {
    public readonly modalTitle: React.ReactNode | string;
    public readonly modalBody: React.ReactNode | string;
    public readonly modalAnythingElseChangedTitle: React.ReactNode | string;
    public readonly modalAnythingElseChangedBody: React.ReactNode | string;

    constructor(modalTitle: React.ReactNode | string, modalBody: React.ReactNode | string, modalAnythingElseChangedTitle: React.ReactNode | string, modalAnythingElseChangedBody: React.ReactNode | string) {
        this.modalTitle = modalTitle;
        this.modalBody = modalBody;
        this.modalAnythingElseChangedTitle = modalAnythingElseChangedTitle;
        this.modalAnythingElseChangedBody = modalAnythingElseChangedBody;
    }
}



// WEBPACK FOOTER //
// ./src/pages/dashboard/annual/motor/yourCarsPage/modal/MtaSuccessModalWording.ts